export const DATE_FORMAT = 'MMM D, YYYY';
export const CHECK_AVAILABILITY_NUMBER_OF_MONTHS = 6;
export const OFFICE_TYPE_EVENT = 4;
export const DATE_FORMAT_CHECK_AVAILABILITY = 'YYYY-MM-DD';

export const DATE_FORMAT_EXPERIENCE = 'MMMM , YYYY';
export const DEFAULT_TIMEZONE = 'Europe/Brussels';